export default __webpack_public_path__ + "static/media/ClassroomIcon.a0da35ab.png";